<template>
  <div>
    <NewProfile @created="getUserProfiles" />
    <NewGroup @created="getUserGroups" />
    <b-modal
      title="NOVO USUÁRIO"
      id="new_user"
      size="xl"
      no-close-on-backdrop
      hide-footer
      @show="evOnShow"
      @shown="evOnShown"
    >
      <b-overlay :show="loading" opacity="0.99">
        <form @submit.prevent="evOnSubmit">
          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <a
                @click="step = 'INFORMATION'"
                :class="[
                  'nav-link link-annotation-care',
                  step == 'INFORMATION' && 'active',
                ]"
                id="nav-informacoes"
                data-toggle="tab"
                href="#informacoes"
                role="tab"
                aria-controls="informacoes"
                :aria-selected="step == 'INFORMATION'"
                >INFORMAÇÕES</a
              >
              <a
                @click="step = 'PROFESSION'"
                :class="[
                  'nav-link link-annotation-care',
                  step == 'PROFESSION' && 'active',
                ]"
                id="nav-profissao"
                data-toggle="tab"
                href="#profissao"
                role="tab"
                aria-controls="profissao"
                :aria-selected="step == 'PROFESSION'"
                >PROFISSÃO</a
              >
              <a
                @click="step = 'DOCUMENTS'"
                :class="[
                  'nav-link link-annotation-care',
                  step == 'DOCUMENTS' && 'active',
                ]"
                id="nav-documentos"
                data-toggle="tab"
                href="#documentos"
                role="tab"
                aria-controls="documentos"
                :aria-selected="step == 'DOCUMENTS'"
                >DOCUMENTOS</a
              >
              <a
                @click="step = 'ADDRESS'"
                :class="[
                  'nav-link link-annotation-care',
                  step == 'ADDRESS' && 'active',
                ]"
                id="nav-endereco"
                data-toggle="tab"
                href="#endereco"
                role="tab"
                aria-controls="endereco"
                :aria-selected="step == 'ADDRESS'"
                >ENDEREÇO</a
              >
              <a
                @click="step = 'ACCESS'"
                :class="[
                  'nav-link link-annotation-care',
                  step == 'ACCESS' && 'active',
                ]"
                id="nav-acesso"
                data-toggle="tab"
                href="#acesso"
                role="tab"
                aria-controls="acesso"
                :aria-selected="step == 'ACCESS'"
                >ACESSO AO SISTEMA</a
              >
              <a
                @click="step = 'FOREIGN'"
                :class="[
                  'nav-link link-annotation-care',
                  step == 'FOREIGN' && 'active',
                ]"
                id="nav-estrangeiro"
                data-toggle="tab"
                href="#estrangeiro"
                role="tab"
                aria-controls="estrangeiro"
                :aria-selected="step == 'FOREIGN'"
                >ESTRANGEIRO</a
              >
            </div>
          </nav>
          <div class="tab-content">
            <div
              :class="['tab-pane fade', step == 'INFORMATION' && 'show active']"
              id="informacoes"
              role="tabpanel"
              aria-labelledby="nav-informacoes"
            >
              <div class="row">
                <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                  <LabelRequiredField label="Nome" />
                  <input
                    type="text"
                    ref="autofocus"
                    v-model="name"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                  <label>Nome social/Apelido</label>
                  <input type="text" v-model="nickname" class="form-control" />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <label>Data de nascimento</label>
                  <input
                    type="date"
                    v-model="date_of_birth"
                    class="form-control"
                  />
                  <span>{{
                    date_of_birth && date_of_birth.length == 10
                      ? `Idade: ${getAge(date_of_birth)} anos`
                      : ""
                  }}</span>
                </div>
                <!-- <div class="col-xl-3 col-lg-3 col-md-5 col-sm-4 col-12">
                  <label>Raça/Cor</label>
                  <select v-model="race_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in genders"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ String(value.name).toUpperCase() }}
                    </option>
                  </select>
                </div> -->
                <div class="col-xl-2 col-lg-2 col-md-5 col-sm-4 col-12">
                  <label>Gênero</label>
                  <select v-model="gender_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in genders"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ String(value.name).toUpperCase() }}
                    </option>
                  </select>
                </div>
                <!-- <div class="col-xl-2 col-lg-2 col-md-5 col-sm-4 col-12">
                  <label>Sexo</label>
                  <select v-model="sex_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in genders"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ String(value.name).toUpperCase() }}
                    </option>
                  </select>
                </div> -->
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <label>Nacionalidade</label>
                  <input
                    type="text"
                    v-model="nationality"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <label>Município de nascimento</label>
                  <input
                    type="text"
                    v-model="city_of_birth"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <label>UF</label>
                  <select v-model="city_of_birth_uf_id" class="form-control">
                    <option>SELECIONE...</option>
                    <option
                      v-for="value in ufs"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <LabelRequiredField label="Grupo" />
                  <div class="input-group">
                    <select v-model="user_group_id" class="form-control">
                      <option value>SELECIONE...</option>
                      <option
                        v-for="value in userGroups"
                        :key="value.id"
                        :value="value.id"
                      >
                        {{ String(value.name).toUpperCase() }}
                      </option>
                    </select>
                    <div class="input-group-prepend pl-1">
                      <v-btn
                        type="button"
                        class="btn-add"
                        @click="$bvModal.show('new_group')"
                      >
                        <i class="fas fa-plus mr-2 text-twenty"></i> NOVO
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <LabelRequiredField label="Perfil" />
                  <div class="input-group">
                    <select v-model="user_profile_id" class="form-control">
                      <option value>SELECIONE...</option>
                      <option
                        v-for="value in userProfiles"
                        :key="value.id"
                        :value="value.id"
                      >
                        {{ String(value.name).toUpperCase() }}
                      </option>
                    </select>
                    <div class="input-group-prepend pl-1">
                      <v-btn
                        type="button"
                        class="btn-add"
                        @click="$bvModal.show('new_profile')"
                      >
                        <i class="fas fa-plus mr-2 text-twenty"></i> NOVO
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <LabelRequiredField label="Status" />
                  <select v-model="status_type_id" class="form-control">
                    <option value>SELECIONE...</option>
                    <option
                      v-for="value in statusTypes"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ String(value.name).toUpperCase() }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <label>TELEFONE</label>
                  <input
                    type="text"
                    v-model="phone"
                    class="form-control"
                    @input="formatPhone"
                  />
                </div>
              </div>
            </div>
            <div
              :class="['tab-pane fade', step == 'PROFESSION' && 'show active']"
              id="profissao"
              role="tabpanel"
              aria-labelledby="nav-profissao"
            >
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-5 col-sm-12">
                  <div class="mb-3">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="doctor"
                        id="doctor"
                      />
                      <label class="form-check-label" for="doctor">
                        MÉDICO
                      </label>
                    </div>
                    <small class="text-muted d-block">
                      Marque esta opção para aparecer nas receitas!
                    </small>
                  </div>

                  <div class="mb-3">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="technical_responsible"
                        id="technical_responsible"
                      />
                      <label
                        class="form-check-label"
                        for="technical_responsible"
                      >
                        RESPONSÁVEL TÉCNICO
                      </label>
                    </div>
                    <small class="text-muted d-block">
                      Marque esta opção para aparecer RT nas assinaturas do
                      usuário!
                    </small>
                  </div>
                </div>

                <div class="col-xl-8 col-lg-8 col-md-7 col-sm-12">
                  <div class="row">
                    <div class="col-12 mb-3">
                      <label>Cargo</label>
                      <input
                        type="text"
                        v-model="office"
                        class="form-control"
                      />
                    </div>

                    <div class="col-12 mb-3">
                      <label>Conselho de classe profissional</label>
                      <select
                        class="form-control"
                        v-model="professional_class_council"
                      >
                        <option :value="{ id: null, name: null }">
                          NENHUM
                        </option>
                        <option
                          v-for="value in professional_class_councils"
                          :key="value.id"
                          :value="value"
                        >
                          {{ value.name }}
                        </option>
                      </select>
                    </div>

                    <div class="col-12">
                      <div
                        v-if="professional_class_council.name == 'COREN'"
                        class="row p-2 m-0 border rounded"
                        style="background-color: #f9f9f9"
                      >
                        <div class="col-md-4 col-12">
                          <label>UF</label>
                          <select v-model="coren_uf" class="form-control">
                            <option value="">SELECIONE...</option>
                            <option
                              v-for="value in ufs"
                              :key="value.id"
                              :value="value.initials"
                            >
                              {{ value.name }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-4 col-12">
                          <label>Código</label>
                          <input
                            type="text"
                            v-model="coren_code"
                            @input="formatCoren"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-4 col-12">
                          <label>Categoria</label>
                          <select v-model="coren_category" class="form-control">
                            <option value="">SELECIONE...</option>
                            <option value="ENF">Enfermeiro(a)</option>
                            <option value="TE">Técnico de Enfermagem</option>
                          </select>
                        </div>
                      </div>

                      <div
                        v-if="
                          professional_class_council &&
                          professional_class_council.name != 'COREN' &&
                          professional_class_council.id
                        "
                        class="row p-2 m-0 border rounded"
                        style="background-color: #f9f9f9"
                      >
                        <div class="col-md-6 col-12">
                          <label>{{ professional_class_council.name }}</label>
                          <input
                            type="text"
                            placeholder="Somente números"
                            v-model="crm_value"
                            v-mask="'##########'"
                            class="form-control"
                          />
                        </div>
                        <div class="col-md-6 col-12">
                          <label>UF</label>
                          <select v-model="crm_uf" class="form-control">
                            <option value="">SELECIONE...</option>
                            <option
                              v-for="value in ufs"
                              :key="value.id"
                              :value="value.initials"
                            >
                              {{ value.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              :class="['tab-pane fade', step == 'DOCUMENTS' && 'show active']"
              id="documentos"
              role="tabpanel"
              aria-labelledby="nav-documentos"
            >
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <LabelRequiredField label="CPF" />
                  <BInputCPF v-model="cpf" />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <label>Número de identidade</label>
                  <input
                    type="text"
                    v-model="identity_number"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <label>Complemento</label>
                  <input
                    type="text"
                    v-model="complement"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <label>UF</label>
                  <select v-model="complement_uf_id" class="form-control">
                    <option>SELECIONE...</option>
                    <option
                      v-for="value in ufs"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <label>Órgão</label>
                  <input
                    type="text"
                    v-model="complement_agency"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <label>Data de emissão</label>
                  <input
                    type="date"
                    v-model="complement_issue_date"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                  <label>Número do cartão nacional de saúde (CNS)</label>
                  <input
                    type="text"
                    v-model="national_health_card_number"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                  <label>Código e descrição CBO</label>
                  <input
                    type="text"
                    v-model="code_and_description"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div
              :class="['tab-pane fade', step == 'ADDRESS' && 'show active']"
              id="endereco"
              role="tabpanel"
              aria-labelledby="nav-endereco"
            >
              <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <label>CEP</label>
                  <BInputCEP v-model="cep" @retrieved="evOnCEPRetrieved" />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <label>CIDADE</label>
                  <input type="text" v-model="city" class="form-control" />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <label>UF</label>
                  <select v-model="uf_id" class="form-control">
                    <option>SELECIONE...</option>
                    <option
                      v-for="value in ufs"
                      :key="value.id"
                      :value="value.id"
                    >
                      {{ value.name }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <label>ENDEREÇO</label>
                  <input type="text" v-model="address" class="form-control" />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <label>Nº ENDEREÇO</label>
                  <input
                    type="text"
                    v-model="number_address"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                  <label>BAIRRO</label>
                  <input type="text" v-model="district" class="form-control" />
                </div>
              </div>
            </div>
            <div
              :class="['tab-pane fade', step == 'ACCESS' && 'show active']"
              id="acesso"
              role="tabpanel"
              aria-labelledby="nav-acesso"
            >
              <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  <LabelRequiredField label="E-mail" />
                  <input type="email" v-model="email" class="form-control" />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <!-- <b-form-checkbox
                    id="predefined_password"
                    v-model="predefined_password"
                  >
                  </b-form-checkbox> -->
                  <label for="predefined_password">
                    Senha
                    <strong>
                      <code>*</code>
                    </strong>
                  </label>
                  <b-input-password
                    :disabled="!predefined_password"
                    v-model="password"
                  />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                  <LabelRequiredField label="Confirmação da senha" />
                  <b-input-password
                    :disabled="!predefined_password"
                    v-model="confirm_password"
                  />
                </div>
              </div>
            </div>
            <div
              :class="['tab-pane fade', step == 'FOREIGN' && 'show active']"
              id="estrangeiro"
              role="tabpanel"
              aria-labelledby="nav-estrangeiro"
            >
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <label> Data de naturalização (Estrangeiro) </label>
                  <input
                    type="date"
                    v-model="naturalization_date"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <label>País de nascimento (Estrangeiro)</label>
                  <input
                    type="text"
                    v-model="country_of_birth"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <label>Número do passaporte (Estrangeiro)</label>
                  <input
                    type="text"
                    v-model="passport_number"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <label>País emissor (Estrangeiro)</label>
                  <input
                    type="text"
                    v-model="issuing_country"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <label>Data de emissão (Estrangeiro)</label>
                  <input
                    type="date"
                    v-model="date_of_issue"
                    class="form-control"
                  />
                </div>
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <label>Data de validade (Estrangeiro)</label>
                  <input
                    type="date"
                    v-model="expiry_date"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <WarningRequiredFields />
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn type="submit" class="btn-add">
              <i class="fas fa-check mr-2 text-twenty"></i>
              SALVAR
            </v-btn>
          </div>
        </form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import LabelRequiredField from "../Components/LabelRequiredField";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import ErrorsMessages from "../Components/ErrorsMessages";
import NewProfile from "../Profiles/NewProfile";
import NewGroup from "../Groups/NewGroup";
import BInputPassword from "../Components/BInputPassword.vue";

import api from "../../services/api";

import { getAge } from "../../lib/getAgeByDate";

import toast from "../../lib/ToastNotification";

import { getStatic } from "../../lib/functions";

import { formatDateToUs } from "../../lib/format";
import BInputCEP from "../Components/BInputCEP.vue";
import BInputCPF from "../Components/BInputCPF.vue";

export default {
  name: "NewUser",
  components: {
    LabelRequiredField,
    WarningRequiredFields,
    ErrorsMessages,
    NewProfile,
    NewGroup,
    BInputPassword,
    BInputCEP,
    BInputCPF,
  },
  data() {
    return {
      step: "INFORMATION",
      errors: [],
      loading: false,

      name: "",
      nickname: "",
      mothers_name: "",
      sex_id: "",
      gender_id: "",
      date_of_birth: "",
      race_id: "",
      nationality: "",
      city_of_birth: "",
      city_of_birth_uf_id: "",
      naturalization_date: "",
      country_of_birth: "",
      passport_number: "",
      issuing_country: "",
      date_of_issue: "",
      expiry_date: "",
      identity_number: "",
      complement: "",
      complement_uf_id: "",
      complement_agency: "",
      complement_issue_date: "",
      national_health_card_number: "",
      code_and_description: "",
      cpf: "",
      email: "",
      phone: "",

      predefined_password: true,
      password: "",
      confirm_password: "",

      user_group_id: "",
      userGroups: [],

      user_profile_id: "",
      userProfiles: [],

      status_type_id: "",
      statusTypes: [],

      professional_class_council: "",
      professional_class_councils: [],
      genders: [],
      coren_uf: "",
      coren_code: "",
      coren_category: "",

      crm_value: "",
      crm_uf: "",

      doctor: false,
      technical_responsible: false,

      cep: "",
      city: "",
      uf_id: "",
      address: "",
      district: "",
      number_address: "",
      office: "",

      ufs: [],
    };
  },
  created() {
    this.setup();
  },
  methods: {
    getAge,
    formatDateToUs,

    async evOnCEPRetrieved(value) {
      this.cep = value.cep;
      this.city = value.localidade || this.city;
      this.neighborhood = value.bairro || this.neighborhood;
      // this.complement = value.complemento || this.complement;
      this.address = value.logradouro || this.address;

      const matched_uf = this.ufs.find(
        (item) => item.initials.toLowerCase() === value.uf.toLowerCase()
      );
      if (matched_uf) this.uf_id = matched_uf.id;
    },

    async setup() {
      if (this.errors.length == 0) await this.getStatusUsers();
      if (this.errors.length == 0) await this.getUserGroups();
      if (this.errors.length == 0) await this.getUserProfiles();
      if (this.errors.length == 0) await this.getGenders();

      if (this.errors.length > 0) return;

      try {
        this.ufs = (await getStatic("/ufs", true)).ufs;
        this.professional_class_councils = (
          await getStatic("/professional-class-councils", true)
        ).professional_class_councils;
      } catch (errors) {
        this.errors = errors;
      }
    },

    async evOnShow() {
      this.errors = [];
      this.loading = false;

      this.name = "";
      this.cpf = "";
      this.email = "";
      this.phone = "";

      this.predefined_password = true;
      this.password = "";
      this.confirm_password = "";

      this.user_group_id = "";
      this.user_profile_id = "";
      this.status_type_id = "";
      this.professional_class_council = "";

      this.coren_uf = "";
      this.coren_code = "";
      this.coren_category = "";

      this.crm_value = "";
      this.crm_uf = "";

      this.doctor = false;
      this.technical_responsible = false;

      this.cep = "";
      this.city = "";
      this.uf_id = "";
      this.address = "";
      this.district = "";
      this.number_address = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        let professional_class_council_value;
        if (this.professional_class_council.name == "COREN") {
          professional_class_council_value = `COREN-${this.coren_uf}-${this.coren_code}-${this.coren_category}`;
        } else if (this.professional_class_council.id) {
          professional_class_council_value = `${this.professional_class_council.name}-${this.crm_uf} ${this.crm_value}`;
        }

        let params = {
          status_type_id: this.status_type_id,
          user_group_id: this.user_group_id,
          user_profile_id: this.user_profile_id,
          name: this.name,
          cpf: this.cpf,
          professional_class_council_id: this.professional_class_council.id,
          professional_class_council_value,
          email: this.email,
          uf_id: this.uf_id,
          phone: this.phone,
          cep: this.cep,
          city: this.city,
          address: this.address,
          number_address: this.number_address,
          district: this.district,
          password: this.predefined_password ? this.password : null,
          confirm_password: this.predefined_password
            ? this.confirm_password
            : null,
          predefined_password: this.predefined_password,
          doctor: this.doctor,
          technical_responsible: this.technical_responsible,
          office: this.office,
          nickname: this.nickname,
          mothers_name: this.mothers_name,
          sex_id: this.sex_id,
          gender_id: this.gender_id,
          date_of_birth: this.date_of_birth,
          race_id: this.race_id,
          nationality: this.nationality,
          city_of_birth: this.city_of_birth,
          city_of_birth_uf_id: this.city_of_birth_uf_id,
          naturalization_date: this.naturalization_date,
          country_of_birth: this.country_of_birth,
          passport_number: this.passport_number,
          issuing_country: this.issuing_country,
          date_of_issue: this.date_of_issue,
          expiry_date: this.expiry_date,
          identity_number: this.identity_number,
          complement: this.complement,
          complement_uf_id: this.complement_uf_id,
          complement_agency: this.complement_agency,
          complement_issue_date: this.complement_issue_date,
          national_health_card_number: this.national_health_card_number,
          code_and_description: this.code_and_description,
        };

        const response = await api.post("/rest-home/user", params);
        const { error, errors, message, step } = response.data;

        if (!error) {
          this.$bvModal.hide("new_user");
          toast(message, "success");
          this.$emit("created");
        } else {
          this.errors = errors;
          this.step = step;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    /** formaters */
    async formatPhone() {
      let filter = this.phone.replace(/[^0-9]/g, "");
      if (filter.length <= 10) {
        this.phone = filter.replace(
          /^([0-9]{2})([0-9]{4})([0-9]{4})$/,
          "($1) $2-$3"
        );
      } else if (filter.length == 11) {
        this.phone = filter.replace(
          /^([0-9]{2})([0-9]{1})([0-9]{4})([0-9]{4})$/,
          "($1) $2.$3-$4"
        );
      } else {
        this.phone = filter.replace(/^([0-9]{2})([0-9]*)$/, "($1) $2");
      }
    },

    async formatCoren() {
      this.coren_code = this.coren_code.toUpperCase();

      let filter = this.coren_code.replace(/[^A-Z0-9]/g, "");
      if (filter.match(/^([A-Z]{2})([0-9]{5,7})([A-Z]{2,4})$/)) {
        this.coren_code = filter.replace(
          /^([A-Z]{2})([0-9]{3})([0-9]{2,4})([A-Z]{2,4})$/,
          "COREN-$1-$2.$3-$4"
        );
      } else if (filter.match(/^(COREN)([A-Z]{2})([0-9]{5,7})([A-Z]{2,4})$/)) {
        this.coren_code = filter.replace(
          /^(COREN)([A-Z]{2})([0-9]{3})([0-9]{2,4})([A-Z]{2,4})$/,
          "$1-$2-$3.$4-$5"
        );
      }
    },

    /** retrievers */
    async getStatusUsers() {
      try {
        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          type: "USUARIO",
        };

        const response = await api.get("/rest-home/type/status/all", {
          params,
        });

        const { error, errors, status } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.statusTypes = status;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getUserGroups() {
      try {
        const response = await api.get("/rest-home/groups");

        const { error, errors, groups } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.userGroups = groups;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getUserProfiles() {
      try {
        const response = await api.get("/rest-home/profiles");

        const { error, errors, profiles } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.userProfiles = profiles;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getGenders() {
      try {
        const response = await api.get("/genders");

        const { error, errors, genders } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.genders = genders;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
